var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniCityscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "657px",
    height: "253px",
    viewBox: "0 0 657 253",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vesta-home-new-props-desk-med-01.0.0",
    transform: "translate(-559.000000, -1674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "property-alert-pt.2",
    transform: "translate(0.000000, 631.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(64.000000, 1037.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact-cityscape-01",
    transform: "translate(853.000000, 130.000000) scale(-1, 1) translate(-853.000000, -130.000000) translate(494.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAB53C",
    points: "379 260 380.53914 203.510077 457.990838 151.009191 457.990838 151 457.990838 151 458 151 457.990838 151.009191 434.399861 258.658066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.29,
    points: "379 260 380.539318 203.505313 458 151 434.406286 258.657952"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "403 243 403 204 426 204"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "379 244 379.211332 236.305703 379.211332 242.323386 401.851455 203.661583 380.415008 203.661583 381.398162 203 403 203 403 203 403 203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "401.871756 245.670956 379.631816 245.670956 379.631816 259.990809 379 260 379.406168 245 403 245 403 245 403 245 394.714178 259.613971 393.946973 259.632353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "403 188.364055 403.670659 187.912442 403.670659 200.511521 415.723886 179.857143 417 179 403 203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,245 L427,203 L403,203 L403,245 Z M403.64938,203.66522 L425.863585,203.66522 L403.640361,242.539596 L403.64938,203.66522 Z",
    id: "Shape",
    fill: "#0C4D5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "403 245 403 245 403 245 427 245 427 245 427 245 419.063134 258.616071 418.296505 258.633929 425.863585 245.651786 403.64938 245.651786 403.64938 258.982143 403 259 403 245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "427 203 427 172.138021 427.64938 171.691406 427.64938 200.539062 449.863585 161.65625 442.35062 161.65625 443.32469 161 451 161 451 161 451 161"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "427 203 446 203 445.852927 203.66522 427.661829 203.66522 427.661829 242.539596 443.122883 216.003688 442.644896 218.136038 427 245 427 203 427 203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "427 245 437 245 436.848197 245.679973 427.683112 245.679973 427.683112 258.981371 427 259 427 245 427 245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "452 155.506369 452.661765 155.047771 452.661765 158.429936 455.740809 152.878981 457 152 452 161"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "452.687351 161.641509 452.687351 175.068658 452 178 452 161 452 161 452 161 456 161 455.856802 161.641509"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#31667A",
    points: "190.303369 251.678415 190 251.981624 190.156281 251.935683 190.156281 252 190.156281 252 190.239018 251.926495 223.287806 242.1687 223.287806 242.1687 223.36135 242.1687 223.36135 242.1687 223.416508 242.1687 227.093703 241.056936 259.958632 231.335894 259.64607 231.225636 260.013789 231.335894 260.068947 231.335894 296.748966 242.187076 330 252 330 252 309.775428 216.662449 309.775428 216.662449 291.876683 185.422805 291.876683 185.422805 260.114912 130 241.103815 163.077271 220.290892 199.149872 210.307308 216.552192 210.307308 216.552192 210.307308 216.552192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,230.500887 L286.478728,185.888747 L281.913205,177.924911 L266.436083,151.036657 C266.436083,151.082479 266.381296,151.109972 266.381296,151.100808 C266.387704,151.067513 266.387704,151.033295 266.381296,151 L251.196368,177.347556 L243.498896,190.810012 L243.800221,190.571738 L222.031808,228.668013 L221,230.500887 L265.742123,243.807548 L266.399558,244 L312,230.500887 Z",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.29,
    fill: "#3A798D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#31667A",
    points: "426 260 380.165444 211 221.834556 211 176 260"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.29,
    fill: "#18A4A8",
    points: "106.073618 204.817971 125.5 117.453378 144.935546 204.817971 214 258 125.646614 104 37 258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,260 L54,0 C54,0 96.6617375,57.8531631 96.8373383,57.7614782 L109,260 L54,260 Z",
    id: "Path",
    fill: "#31667A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A0AF",
    points: "86 44 54 44 54 42 84.6107091 42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A0AF",
    points: "80.457561 93.6683569 96.6622439 121.729636 96.6805854 121.702125 100.74322 128.799978 101 133 96.4604878 125.085986 96.4513171 125.104326 78.8435122 94.6037329 54 51.7231632 54 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A0AF",
    points: "55 166 81.2670713 211.594624 97.3459788 239.592286 97.3641882 239.573975 109 260 106.295903 259.011201 97.1638847 242.979838 97.15478 242.998149 79.6646434 212.528489 55 169.726308"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A0AF",
    points: "103 161 54 161 54 159 102.889161 159"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    points: "54 0 96.8373383 57.7360087 109 260 108.990758 260 54 260"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "92 182 92.5028746 181.622214 116.869433 159 201.334072 159.593664 224 180.641768"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    points: "92 182 116.482169 159 201.252138 159.602859 224 180.9861"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#BDC1C4",
    x: 163,
    y: 156,
    width: 70,
    height: 104
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#BDC1C4",
    x: 161,
    y: 150,
    width: 73,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#BDC1C4",
    x: 93,
    y: 182,
    width: 70,
    height: 78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 132,
    y: 192,
    width: 24,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.727405,195.253354 L151.693565,198.213623 C151.992727,198.512871 152.082251,198.96306 151.92037,199.354152 C151.758489,199.745245 151.377103,200.000171 150.954149,199.999992 C150.676666,200.001053 150.410336,199.89075 150.214734,199.693758 L147.257074,196.733488 C146.896986,196.31968 146.917495,195.697737 147.304061,195.308594 C147.690626,194.919451 148.311893,194.895339 148.727405,195.253354 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.942997,196.333381 L152.666461,205.057244 C152.992084,205.382688 153.089526,205.872286 152.913327,206.297615 C152.737127,206.722944 152.322008,207.000185 151.861645,206.999992 C151.559619,207.001145 151.269732,206.881187 151.056829,206.666949 L142.333366,197.943086 C141.888878,197.498578 141.888878,196.777889 142.333366,196.333381 C142.777853,195.888873 143.49851,195.888873 143.942997,196.333381 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 99,
    y: 192,
    width: 24,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.767722,195.303319 L119.696579,198.232427 C119.89085,198.426599 120,198.690022 120,198.964704 C120,199.239386 119.89085,199.502809 119.696579,199.696981 C119.502882,199.8919 119.239146,200.001042 118.964365,199.999993 C118.689951,199.999192 118.426895,199.890332 118.232151,199.696981 L115.303293,196.767873 C114.898902,196.363448 114.898902,195.707745 115.303293,195.303319 C115.707684,194.898894 116.363331,194.898894 116.767722,195.303319 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.944639,196.333381 L119.666212,205.057244 C119.879926,205.27066 120,205.560191 120,205.862097 C120,206.164002 119.879926,206.453533 119.666212,206.666949 C119.45313,206.881187 119.162998,207.001145 118.860717,206.999992 C118.558839,206.999112 118.269456,206.879462 118.055221,206.666949 L109.333647,197.943086 C108.888784,197.498578 108.888784,196.777889 109.333647,196.333381 C109.77851,195.888873 110.499776,195.888873 110.944639,196.333381 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 132,
    y: 225,
    width: 24,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.727405,228.252924 L151.693565,231.216657 C151.992727,231.515397 152.082251,231.964821 151.92037,232.355249 C151.758489,232.745678 151.377103,233.00017 150.954149,232.999992 C150.676666,233.001051 150.410336,232.890936 150.214734,232.694278 L147.257074,229.730544 C146.896986,229.317439 146.917495,228.696552 147.304061,228.30807 C147.690626,227.919588 148.311893,227.895517 148.727405,228.252924 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.942997,229.333661 L152.666461,238.055609 C152.992084,238.381327 153.089526,238.871337 152.913327,239.297024 C152.737127,239.722711 152.322008,240.000186 151.861645,239.999992 C151.559619,240.001146 151.269732,239.881087 151.056829,239.666669 L142.333366,230.944722 C141.888878,230.49984 141.888878,229.778544 142.333366,229.333662 C142.777853,228.88878 143.49851,228.888779 143.942997,229.333661 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 99,
    y: 225,
    width: 24,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.767722,228.302809 L119.696579,231.235398 C119.89085,231.429243 120,231.692224 120,231.966444 C120,232.240665 119.89085,232.503645 119.696579,232.697491 C119.502882,232.892082 119.239146,233.00104 118.964365,232.999993 C118.689951,232.999193 118.426895,232.890516 118.232151,232.697491 L115.303293,229.764902 C114.898902,229.361156 114.898902,228.706555 115.303293,228.302809 C115.707684,227.899064 116.363331,227.899064 116.767722,228.302809 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.944639,229.333662 L119.666212,238.055609 C119.879926,238.269204 120,238.558979 120,238.861139 C120,239.163299 119.879926,239.453073 119.666212,239.666669 C119.45313,239.881087 119.162998,240.001146 118.860717,239.999992 C118.558839,239.999111 118.269456,239.879361 118.055221,239.666669 L109.333647,230.944722 C108.888784,230.49984 108.888784,229.778544 109.333647,229.333662 C109.77851,228.888779 110.499776,228.888779 110.944639,229.333662 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 202,
    y: 173,
    width: 24,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.754093,176.303319 L221.696742,179.240844 C221.890858,179.433577 222,179.695607 222,179.968913 C222,180.242218 221.890858,180.504248 221.696742,180.696981 C221.501641,180.890332 221.238104,180.999192 220.963188,180.999993 C220.687904,181.001042 220.423685,180.8919 220.229634,180.696981 L217.303848,177.767873 C216.898717,177.363448 216.898717,176.707745 217.303848,176.303319 C217.708979,175.898894 218.365826,175.898894 218.770957,176.303319 L218.754093,176.303319 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.973362,177.333661 L221.667579,186.055609 C221.99211,186.381327 222.089226,186.871337 221.913617,187.297024 C221.738008,187.722711 221.324281,188.000186 220.865461,187.999992 C220.564448,188.001146 220.275533,187.881087 220.063344,187.666669 L211.332248,178.944722 C210.889251,178.49984 210.889251,177.778544 211.332248,177.333662 C211.775245,176.88878 212.493486,176.888779 212.936483,177.333661 L212.973362,177.333661 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 169,
    y: 173,
    width: 24,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77065,176.30332 L189.704359,179.240849 C189.99514,179.537691 190.080164,179.979273 189.920345,180.362604 C189.760526,180.745934 189.386787,180.996847 188.970932,181 C188.696064,180.999199 188.432572,180.890339 188.237504,180.696988 L185.303796,177.767876 C184.898735,177.36345 184.898735,176.707746 185.303796,176.30332 C185.708856,175.898893 186.365589,175.898893 186.77065,176.30332 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.853779,177.277223 L189.664578,186.04532 C189.879338,186.260046 190,186.551354 190,186.855113 C190,187.158872 189.879338,187.450179 189.664578,187.664905 C189.450452,187.880457 189.1589,188.001152 188.855138,187.999992 C188.551783,187.999106 188.260983,187.878723 188.045698,187.664905 L179.281419,178.896808 C178.88723,178.444013 178.909681,177.763474 179.332856,177.337668 C179.756031,176.911862 180.436133,176.885479 180.890995,177.277223 L180.853779,177.277223 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#BDC1C4",
    x: 163,
    y: 255,
    width: 70,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#BDC1C4",
    x: 93,
    y: 255,
    width: 70,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#17A3A7",
    x: 178,
    y: 214,
    width: 40,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.767722,218.303336 L213.696579,221.232614 C213.89085,221.426797 214,221.690235 214,221.964933 C214,222.239631 213.89085,222.50307 213.696579,222.697253 C213.503863,222.891042 213.241855,223 212.968573,223 C212.695291,223 212.433283,222.891042 212.240567,222.697253 L209.303293,219.767975 C208.898902,219.363526 208.898902,218.707785 209.303293,218.303337 C209.707684,217.898888 210.363331,217.898888 210.767722,218.303336 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.944639,218.33339 L213.666212,227.057505 C213.879926,227.270928 214,227.560467 214,227.862381 C214,228.164296 213.879926,228.453835 213.666212,228.667257 C213.454209,228.880247 213.165979,229 212.865346,229 C212.564713,229 212.276483,228.880247 212.06448,228.667257 L203.333647,219.943142 C202.888784,219.498622 202.888784,218.777911 203.333647,218.333391 C203.77851,217.88887 204.499776,217.88887 204.944639,218.33339 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,260 L197.5,214",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.87
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 250,
    y: 215,
    width: 93,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 250,
    y: 255,
    width: 93,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 287,
    y: 228,
    width: 19,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#EC6734",
    points: "261.216009 179 248 215 345 215 331.783991 179"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    points: "261.216009 179 248 215 345 215 331.783991 179"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#EAEBEC",
    x: 322,
    y: 228,
    width: 17,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.609107,230.241757 L324.242603,232.586173 C324.087296,232.740781 324,232.950797 324,233.169825 C324,233.388854 324.087296,233.59887 324.242603,233.753477 C324.396049,233.911085 324.606779,234 324.826865,234 C325.04695,234 325.25768,233.911085 325.411126,233.753477 L327.757991,231.40906 C328.08067,231.086718 328.08067,230.564099 327.757991,230.241757 C327.435312,229.919414 326.912147,229.919414 326.589468,230.241757 L326.609107,230.241757 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.569042,230.278532 L324.241259,236.593271 C324.086812,236.747103 324,236.956064 324,237.173993 C324,237.391922 324.086812,237.600883 324.241259,237.754715 C324.393854,237.911531 324.603416,238 324.822282,238 C325.041148,238 325.25071,237.911531 325.403305,237.754715 L331.721323,231.449736 C331.951702,231.245102 332.049668,230.929732 331.975753,230.630672 C331.901838,230.331612 331.668215,230.098111 331.369001,230.024235 C331.069786,229.950358 330.754251,230.048273 330.549511,230.278532 L330.569042,230.278532 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#EAEBEC",
    x: 254,
    y: 228,
    width: 17,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.609107,230.241757 L256.242603,232.586173 C256.087296,232.740781 256,232.950797 256,233.169825 C256,233.388854 256.087296,233.59887 256.242603,233.753477 C256.396049,233.911085 256.606779,234 256.826865,234 C257.04695,234 257.25768,233.911085 257.411126,233.753477 L259.757991,231.40906 C260.08067,231.086718 260.08067,230.564099 259.757991,230.241757 C259.435312,229.919414 258.912147,229.919414 258.589468,230.241757 L258.609107,230.241757 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.569042,230.278532 L256.241259,236.593271 C256.086812,236.747103 256,236.956064 256,237.173993 C256,237.391922 256.086812,237.600883 256.241259,237.754715 C256.393854,237.911531 256.603416,238 256.822282,238 C257.041148,238 257.25071,237.911531 257.403305,237.754715 L263.721323,231.449736 C263.951702,231.245102 264.049668,230.929732 263.975753,230.630672 C263.901838,230.331612 263.668215,230.098111 263.369001,230.024235 C263.069786,229.950358 262.754251,230.048273 262.549511,230.278532 L262.569042,230.278532 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,244 C288.447715,244 288,244.357321 288,244.7981 L288,247.2019 C288,247.642679 288.447715,248 289,248 C289.552285,248 290,247.642679 290,247.2019 L290,244.7981 C289.993571,244.359464 289.5496,244.005131 289,244 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 276,
    y: 221,
    width: 5,
    height: 39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 274,
    y: 257,
    width: 9,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 273,
    y: 221,
    width: 10,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 313,
    y: 221,
    width: 5,
    height: 39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 311,
    y: 257,
    width: 9,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 310,
    y: 221,
    width: 10,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#EC6734",
    points: "275 221 319 221 297.004577 199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,179 L306,208",
    id: "Path",
    stroke: "#003D4F",
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003D4F",
    strokeWidth: 1.56,
    points: "329 179 334.320555 202.463993 334.320555 202.463993 343 209"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003D4F",
    strokeWidth: 1.56,
    points: "310 212 321.723507 202.916409 327 179"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003D4F",
    strokeWidth: 1.56,
    points: "270 179 275.134409 202.343209 275.134409 202.343209 285 210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,212 L261.704801,202.415541 C261.704801,202.415541 265.179775,187.038578 267,179",
    id: "Path",
    stroke: "#003D4F",
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,206 L273,179",
    id: "Path",
    stroke: "#003D4F",
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 0.79,
    fill: "#EAEBEC",
    x: 227,
    y: 221,
    width: 19,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,234 L236.5,260",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#BDC1C4",
    x: 361,
    y: 168,
    width: 4,
    height: 92
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.73,
    fill: "#BDC1C4",
    x: 360,
    y: 246,
    width: 6,
    height: 14
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#F9B43B",
    transform: "translate(363.036790, 167.589345) rotate(-45.000000) translate(-363.036790, -167.589345) ",
    cx: 363.03679,
    cy: 167.589345,
    r: 8.67919571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.999338,175 L357.000662,175 C356.448012,175 356,175.447715 356,176 C356,176.552285 356.448012,177 357.000662,177 L368.999338,177 C369.551988,177 370,176.552285 370,176 C370,175.447715 369.551988,175 368.999338,175 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.958617,204.004645 L359.041383,204.004645 C358.68175,203.968094 358.333547,204.149412 358.142949,204.472482 C357.95235,204.795551 357.95235,205.204449 358.142949,205.527518 C358.333547,205.850588 358.68175,206.031906 359.041383,205.995355 L366.958617,205.995355 C367.31825,206.031906 367.666453,205.850588 367.857051,205.527518 C368.04765,205.204449 368.04765,204.795551 367.857051,204.472482 C367.666453,204.149412 367.31825,203.968094 366.958617,204.004645 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 434,
    y: 151,
    width: 80,
    height: 109
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 434,
    y: 233,
    width: 32,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#17A3A7",
    x: 466,
    y: 233,
    width: 48,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    x: 466,
    y: 233,
    width: 48,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 440,
    y: 198,
    width: 19,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 432,
    y: 145,
    width: 84,
    height: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F5B335",
    points: "492.142857 251.037172 492.026786 250.854956 481.741071 234 480 234 495.258929 259 497 259"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F5B335",
    points: "496.64966 145 495 145 498.35034 151 500 151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5B335",
    x: 473,
    y: 145,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F5B335",
    points: "441 148 441 151 443 151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 476,
    y: 239,
    width: 26,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,214 C443.447715,214 443,214.425095 443,214.949477 L443,218.050523 C443,218.574905 443.447715,219 444,219 C444.552285,219 445,218.574905 445,218.050523 L445,214.949477 C445,214.69766 444.894643,214.456157 444.707107,214.278095 C444.51957,214.100034 444.265216,214 444,214 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,239.5 L466,239.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,246.5 L466,246.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,253.5 L466,253.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,246.5 L502,246.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.5,255 L484.5,238",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5,255 L493.5,238",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 477,
    y: 198,
    width: 26,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,214.5 L503,214.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,206.5 L503,206.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.5,223 L485.5,198",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5,223 L493.5,198",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 477,
    y: 163,
    width: 26,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,179.5 L503,179.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,171.5 L503,171.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.5,188 L485.5,163",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5,188 L493.5,163",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#BDC1C4",
    x: 441,
    y: 163,
    width: 26,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,179.5 L466,179.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,171.5 L466,171.5",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.5,188 L449.5,163",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.5,188 L457.5,163",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    x: 432,
    y: 145,
    width: 84,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.816157,260 L324.619222,260 L324.408822,259.801413 C323.504357,258.968095 322.993674,257.799912 323.000059,256.57888 C323.000054,254.119657 325.017718,252.124667 327.50993,252.119688 L327.720329,252.119688 C327.766401,252.12112 327.810465,252.101052 327.839251,252.065528 C327.860521,252.022835 327.860521,251.972821 327.839251,251.930128 C327.697917,251.557841 327.626616,251.163229 327.628851,250.765683 C327.628845,248.87977 329.175515,247.349539 331.086724,247.344563 L331.489227,247.344563 C331.551711,247.357229 331.614116,247.322591 331.635592,247.263322 C331.67099,247.211488 331.67099,247.143649 331.635592,247.091815 C330.821733,246.376645 330.358591,245.350837 330.364047,244.275484 C330.36909,242.170223 332.100059,240.466209 334.233571,240.466215 L334.57204,240.466215 C334.609277,240.485477 334.653724,240.485477 334.690961,240.466215 C334.707262,240.425626 334.707262,240.38043 334.690961,240.339841 C334.67701,240.162583 334.67701,239.984524 334.690961,239.807266 C334.69296,238.151026 335.673558,236.648038 337.200629,235.960633 C338.727699,235.273228 340.520764,235.527663 341.789662,236.611813 C341.837778,236.639225 341.897059,236.639225 341.945175,236.611813 C342.002754,236.587796 342.036605,236.528413 342.027505,236.467386 L342.027505,236.413225 C342.024693,235.167366 342.654273,234.002879 343.704518,233.31138 C344.754763,232.619882 346.086139,232.493242 347.250905,232.974052 C347.284804,232.989007 347.323397,232.989768 347.357874,232.97616 C347.392351,232.962552 347.419767,232.935737 347.433861,232.901838 C348.367302,230.92029 350.3658,229.638973 352.579969,229.602463 C354.794138,229.565952 356.834906,230.780664 357.834922,232.730331 C357.863183,232.775897 357.913426,232.803681 357.967565,232.803681 C358.021704,232.803681 358.071947,232.775897 358.100208,232.730331 C359.148839,230.71864 361.066334,229.285523 363.312859,228.834443 C365.559384,228.383364 367.891959,228.963111 369.653893,230.410468 C369.6979,230.428034 369.747103,230.428034 369.79111,230.410468 C369.838932,230.395343 369.876408,230.358363 369.891736,230.311174 C370.532777,228.073095 372.442185,226.41254 374.772861,226.066204 C377.103538,225.719869 379.423867,226.751892 380.704448,228.704421 C380.726474,228.739519 380.763524,228.762784 380.805074,228.767608 C380.842312,228.78687 380.886758,228.78687 380.923996,228.767608 C382.029449,227.804891 383.554919,227.462442 384.973642,227.858514 C386.392366,228.254586 387.509907,229.334897 387.940366,230.726403 C387.95248,230.772318 387.986674,230.809435 388.031844,230.825696 C388.075851,230.843262 388.125055,230.843262 388.169062,230.825696 C389.532211,229.786215 391.294133,229.40075 392.974775,229.774325 C394.655418,230.1479 396.07967,231.241591 396.859482,232.757411 C396.897158,232.814778 396.964439,232.846226 397.03329,232.838651 C397.071593,232.824972 397.101758,232.795207 397.11562,232.757411 C398.166299,230.745332 400.085392,229.312315 402.33325,228.861325 C404.581108,228.410335 406.914933,228.990085 408.678453,230.437548 C408.72246,230.455114 408.771663,230.455114 408.81567,230.437548 C408.86084,230.421286 408.895035,230.38417 408.907148,230.338254 C409.548189,228.100175 411.457597,226.43962 413.788273,226.093284 C416.11895,225.746949 418.439279,226.778972 419.71986,228.731501 C419.743766,228.769022 419.784768,228.792623 419.829634,228.794688 C419.864036,228.81235 419.905005,228.81235 419.939408,228.794688 C420.930503,227.927495 422.269544,227.556037 423.573389,227.786601 C424.877235,228.017166 426.002222,228.824347 426.626457,229.977186 C426.664506,230.038582 426.738951,230.067966 426.809413,230.0494 C427.138501,229.93492 427.485031,229.876912 427.833968,229.877893 C429.546663,229.877893 430.935076,231.247925 430.935076,232.937945 C430.938989,232.998061 430.938989,233.058363 430.935076,233.118479 C430.935076,233.235826 430.989963,233.299013 431.072293,233.30804 C433.072321,233.480478 434.610368,235.127244 434.621644,237.108282 C434.621525,237.711686 434.474046,238.306177 434.191697,238.841409 C434.164048,238.892133 434.164048,238.953165 434.191697,239.003889 C434.229588,239.048471 434.290891,239.066263 434.347209,239.049023 C436.644317,238.450329 439.074452,239.345061 440.412683,241.282221 C441.750914,243.219381 441.706743,245.778457 440.302434,247.669524 C440.279666,247.711861 440.279666,247.762587 440.302434,247.804924 C440.32202,247.850803 440.362944,247.884454 440.412208,247.895191 C443.146058,248.376711 445.135762,250.724374 445.132478,253.464667 C445.132478,253.663255 445.132478,253.861842 445.132478,254.051403 C445.135944,254.09314 445.155607,254.131945 445.187365,254.159723 C445.21771,254.193226 445.260762,254.212833 445.306286,254.213883 C447.893011,254.213883 449.989965,256.283076 449.989965,258.835555 C450.003345,259.030911 450.003345,259.226935 449.989965,259.422291 L449.816157,260 Z",
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#17A3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#BDC1C4",
    x: 513,
    y: 188,
    width: 79,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    x: 513,
    y: 188,
    width: 79,
    height: 72
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "570 257 570 218 547 218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "546 257 546 218 523 218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "578.772668 188 578 188 592 212 592 210.688923"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "570 217 570 217 592 255 592 253.654457 571.163283 217.668132 592 217.668132 592 217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "571 188 570.317757 188 570.317757 214.514286 554.785047 188 554 188 571 217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546,217 L570,259 L570,217 L546,217 Z M569.341601,256.539596 L547.127396,217.656108 L569.341601,217.656108 L569.341601,256.539596 Z",
    id: "Shape",
    fill: "#0C4D5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "546 188 545.317757 188 545.317757 214.514286 529.785047 188 529 188 546 217 546 217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.972943,217 L522,217 L546,259 L545.972943,217 Z M545.314543,256.539596 L523.100338,217.656108 L545.314543,217.656108 L545.314543,256.539596 Z",
    id: "Shape",
    fill: "#0C4D5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "522 188 521.319171 188 521.319171 214.514286 513 200.28127 513 201.606984 522 217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0C4D5D",
    points: "513 217 513 217.656108 521.319171 217.656108 521.319171 256.539596 513 242.442395 513 243.763723 522 259 522 217 522 217"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#FAB53C",
    x: 511,
    y: 181,
    width: 83,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 522,
    y: 205,
    width: 26,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.917772,208.312011 L526.367629,211.859127 C525.877457,212.348881 525.877457,213.14293 526.367629,213.632684 C526.857802,214.122439 527.652528,214.122439 528.142701,213.632684 L531.683197,210.085569 C532.123498,209.590676 532.102423,208.838924 531.635085,208.369433 C531.167748,207.899943 530.41548,207.874789 529.917772,208.312011 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.83333,209.420529 L526.362716,218.885147 C525.879095,219.368949 525.879095,220.153347 526.362716,220.637149 C526.846338,221.12095 527.630444,221.12095 528.114066,220.637149 L537.58468,211.163009 C537.928654,210.857126 538.074503,210.385537 537.9633,209.938776 C537.852097,209.492016 537.502219,209.14391 537.055025,209.035102 C536.607832,208.926294 536.13722,209.074765 535.83333,209.420529 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.87,
    fill: "#EAEBEC",
    x: 557,
    y: 205,
    width: 26,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.895346,208.353972 L561.418416,211.842251 C561.074389,212.14489 560.926664,212.613563 561.034926,213.058916 C561.143187,213.504269 561.489544,213.852706 561.934061,213.963451 C562.378578,214.074196 562.847798,213.928947 563.152144,213.58639 L566.638548,210.098112 C566.869961,209.866957 567,209.553215 567,209.226042 C567,208.898869 566.869961,208.585127 566.638548,208.353972 C566.153214,207.882009 565.38068,207.882009 564.895346,208.353972 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.943888,209.361118 L561.420597,218.831259 C561.074777,219.135439 560.926282,219.606501 561.035108,220.054122 C561.143933,220.501743 561.492095,220.851956 561.938928,220.963265 C562.385762,221.074574 562.857427,220.928586 563.163359,220.584283 L572.639034,211.104615 C572.950349,210.793169 573.071931,210.339227 572.957982,209.913784 C572.844033,209.488342 572.511864,209.156033 572.0866,209.042036 C571.661337,208.928039 571.207586,209.049672 570.896272,209.361118 L570.943888,209.361118 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 1.29,
    fill: "#EC6734",
    points: "472 260 595 217 718 260"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 593,
    y: 200,
    width: 75,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 599,
    y: 209,
    width: 40,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 602,
    y: 212,
    width: 33,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 593,
    y: 252,
    width: 75,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    fill: "#18A4A8",
    points: "603.188819 187 590 200 670 200 656.811181 187"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#003C4D",
    strokeWidth: 2.07,
    points: "603.188819 187 590 200 670 200 656.811181 187"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DF6A2E",
    points: "641.86625 199 648 188 647.13375 188 641 199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DF6A2E",
    points: "604.873908 199 611 188 610.134831 188 604 199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DF6A2E",
    points: "637.13591 199 638 199 631.86409 188 631 188"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DF6A2E",
    points: "601.104072 199 602 199 598.579186 193 598 193.568807"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#18A4A8",
    x: 642,
    y: 208,
    width: 22,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 645,
    y: 211,
    width: 17,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.5,237 C644.223858,237 644,237.272123 644,237.607803 L644,240.392197 C644,240.727877 644.223858,241 644.5,241 C644.776142,241 645,240.727877 645,240.392197 L645,237.591376 C644.992677,237.262128 644.77095,236.99988 644.5,237 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#003C4D",
    strokeWidth: 1.61,
    fill: "#BDC1C4",
    x: 587,
    y: 256,
    width: 86,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.006463,214.005058 L647.216686,215.844568 C647.009625,216.032956 646.94301,216.337302 647.051481,216.599346 C647.159952,216.861389 647.419016,217.02196 647.69396,216.997562 C647.862708,216.99377 648.023922,216.924662 648.145666,216.803929 L649.92692,214.955618 C650.05619,214.70298 650.010911,214.39283 649.815261,214.190781 C649.61961,213.988732 649.319283,213.941972 649.074645,214.07547 L649.006463,214.005058 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.029861,215.030746 L647.186629,219.907589 C647.067175,220.027073 647,220.189608 647,220.359149 C647,220.52869 647.067175,220.691225 647.186629,220.810708 C647.301738,220.933779 647.46293,221.002449 647.630806,220.999933 C647.800845,221.000742 647.964037,220.932532 648.083524,220.810708 L652.926756,215.933865 C653.056316,215.686978 653.010936,215.383888 652.814846,215.186439 C652.618757,214.988989 652.317757,214.943293 652.072571,215.073752 L652.029861,215.030746 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.0058,214.14838 L605.285867,215.872251 C605.076426,216.003663 604.966973,216.248896 605.008822,216.492979 C605.050671,216.737062 605.235526,216.931604 605.476721,216.985398 C605.717917,217.039193 605.967635,216.941575 606.108802,216.73831 L607.836963,215.006191 C608.054346,214.774418 608.054346,214.413147 607.836963,214.181373 C607.611726,213.952894 607.248359,213.93847 607.0058,214.14838 Z",
    id: "Path",
    fill: "#003C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.985931,215.148233 L605.184999,219.941627 C605.066589,220.059066 605,220.218819 605,220.385459 C605,220.552099 605.066589,220.711853 605.184999,220.829292 C605.421208,221.056903 605.795515,221.056903 606.031724,220.829292 L610.841123,216.035899 C611.052959,215.793786 611.052959,215.432616 610.841123,215.190503 C610.611663,214.953812 610.237683,214.935327 609.985931,215.148233 Z",
    id: "Path",
    fill: "#003C4D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCityscape);
export default __webpack_public_path__ + "static/media/mini-cityscape.9936fbedd23bec42209114786e46d1c5.svg";
export { ForwardRef as ReactComponent };